const phaseMessages = {
  analyzing_descriptions: 'catalog.sync.descriptionAnalysis',
  preparing_description_parameters: 'catalog.sync.descriptionPreparation',
};

const counter = value => (Number.isInteger(value) && value >= 0 ? value : 0);

export function normalizeCatalogSourcePhase(job) {
  const phase =
    ['running', 'queued'].includes(job?.status) &&
    Object.prototype.hasOwnProperty.call(phaseMessages, job?.phase)
      ? job.phase
      : null;
  return {
    phase,
    sourceProcessed: phase
      ? counter(job.source_processed ?? job.sourceProcessed)
      : 0,
    sourceTotal: phase ? counter(job.source_total ?? job.sourceTotal) : 0,
  };
}

export function catalogSourcePhaseLabel(source, localizeMessage) {
  if (!Object.prototype.hasOwnProperty.call(phaseMessages, source?.phase))
    return null;
  const label = localizeMessage(phaseMessages[source.phase]);
  return counter(source.sourceTotal) > 0
    ? `${label} · ${localizeMessage('catalog.sync.sourceProgress', {
        processed: counter(source.sourceProcessed).toLocaleString(),
        total: source.sourceTotal.toLocaleString(),
      })}`
    : label;
}

export function catalogSourceProgress(source) {
  if (
    !Object.prototype.hasOwnProperty.call(phaseMessages, source?.phase) ||
    counter(source.sourceTotal) === 0
  )
    return null;
  return Math.min(
    100,
    (100 * counter(source.sourceProcessed)) / source.sourceTotal,
  );
}
